<template lang="pug">
.surprise-task-container(v-if="visibleTaskList.length")
  img.img(
    src="https://m.hellobike.com/8195a13d_lighting.png"
    alt=""
  )
  .header
    span.header-title {{ moduleData.mainTitle }}
    img.header-icon(src="https://m.hellobike.com/fd018348_new_coin.png")
    span.header-desc {{ moduleData.subTitle }}
  template(v-for="(item,index) in taskList")
    //- 阶梯视频任务
    TieredVideoTask(
      v-if="item.marketPlan === 'incentive_video_scheme'"
      :key="'tiered-' + item.taskCode"
      :taskItem="item"
      :doubleInformation="surpriseDoubleInfo"
      @completed="$emit('expired')"
    )
    //- 优量汇广告任务
    GdtTaskCard(
      v-else-if="item.marketPlan === MARKET_PLAN.GDT_TASK"
      :key="'gdt-' + item.taskCode"
      :task="item"
      :index="index"
      :isSurpriseTask="true"
      :doubleInformation="surpriseDoubleInfo"
      @gdt-change="(hidden) => handleGdtChange(item.taskCode, hidden)"
    )
    //- 吃饭睡觉补贴任务
    SubsidyTask(
      v-else-if="item.taskType === 'meal_subsidy'"
      :key="'subsidy-' + item.taskCode"
      :item="item"
      @click="handleClick(item, index)"
      @countdown-end="$emit('expired')"
    )
    //- 常规任务
    .task(
      v-else
      :key="item.taskCode"
      @click="handleClick(item, index)"
    )
      .task-left
        SafeImg.task-left-img(:src="item.taskImgUrl")
        .task-info
          span.task-title {{ item.guideDesc }}{{item.guideAwardDesc}}
          .task-coin
            img.task-icon(src="https://m.hellobike.com/fd018348_new_coin.png")
            span.task-amount +{{ item.amount }}
            //- 推荐系统角标+文案
            .coupon-badge(v-if="item.couponInfo && item.couponInfo.prizeDesc")
              .coupon-icon
                img(:src="item.couponInfo.icon")
              .coupon-text {{ item.couponInfo.prizeDesc }}
            .task-subtitle(v-else) {{ item.additionalDesc }}
      .task-right(
        :class="{ 'done': item.taskStatus === 'FINISHED','can-do': item.taskStatus === 'RUNNING'}"
      ) {{ item.btnName }}

</template>

<script>
import SafeImg from '@/components/safe-img';
import { jumpUrl } from '@/utils/tools';
import { env } from '@hb/NBridge/lib/h5';
import { handleTaskBtnClick } from '../../common/task';
import SPM from '../../common/spm';
import { MARKET_PLAN } from '../../consts';
import TieredVideoTask from './tiered-video-task.vue';
import GdtTaskCard from './gdt-task-card.vue';
import SubsidyTask from './subsidy-task.vue';

export default {
  name: 'SurpriseTask',
  components: {
    SafeImg,
    TieredVideoTask,
    GdtTaskCard,
    SubsidyTask,
  },
  inject: {
    isSupportAd: {
      default: () => () => false,
    },
  },
  props: {
    moduleData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      doubleInformationHistory: null,
      MARKET_PLAN,
      hiddenGdtTasks: {},
    };
  },
  computed: {
    // 从 moduleData 中获取任务列表
    taskList() {
      return this.moduleData.taskCouponList || [];
    },
    // 过滤掉广告加载失败的 GDT 任务，有可见任务才展示模块
    visibleTaskList() {
      return this.taskList.filter((item) => {
        if (item.marketPlan !== MARKET_PLAN.GDT_TASK) return true;
        return this.hiddenGdtTasks[item.taskCode] !== true;
      });
    },
    surpriseDoubleInfo() {
      return {
        bannerAdvertisementUnitId: this.moduleData.bannerAdvertisementUnitId,
        bannerTaskRelationCouponInfo: this.moduleData.bannerTaskRelationCouponInfo,
      };
    },
  },
  watch: {
    surpriseDoubleInfo: {
      handler(newVal) {
        // 用完后置空，保存在 data 中
        this.doubleInformationHistory = { ...newVal };
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // 惊喜任务模块曝光埋点
    this.taskList.forEach((item, index) => {
      SPM.moduleExpose({
        moduleId: 'platform_surpriseTask',
        contentId: 'platform_surpriseTask',
        businessInfo: {
          rankNum: index + 1,
          taskBonus: item.amount || '',
          taskId: item.taskCode || '',
          taskname: item.mainTitle || item.taskName || '',
          task_status: item.taskStatus || '',
          btn_name: item.btnName || '',
          clk_url: (item.btnLink && item.btnLink.app) || item.titleBarUrl || '',
        },
      });
    });
  },
  methods: {
    handleGdtChange(taskCode, hidden) {
      this.$set(this.hiddenGdtTasks, taskCode, hidden);
    },
    async handleClick(item, index) {
      // 惊喜任务点击埋点
      SPM.clickButton({
        buttonName: 'platform_surpriseTask',
        businessInfo: {
          rankNum: index + 1,
          taskBonus: item.amount || '',
          taskId: item.taskCode || '',
          taskname: item.mainTitle || item.taskName || '',
          task_status: item.taskStatus || '',
          btn_name: item.btnName || '',
          clk_url: (item.btnLink && item.btnLink.app) || item.titleBarUrl || '',
        },
      });
      // 吃饭睡觉补贴任务：无论状态，统一跳转
      if (item.taskType === 'meal_subsidy') {
        let channel = 'app';
        if (env.isAliMP || env.isAliMPMonitor) {
          channel = 'ali';
        }
        const link = (item.btnLink && item.btnLink[channel])
          || item.titleBarUrl;
        if (link) jumpUrl(link);
        return;
      }
      const options = {
        scene: 'task_list',
        needReceiveCoupon: true,
        doubleInformationHistory: this.doubleInformationHistory,
        supportAd: this.isSupportAd(),
        taskIndex: index,
      };
      const { receiveSuc } = await handleTaskBtnClick.call(
        this, item, options,
      );
      this.doubleInformationHistory = null;
      if (receiveSuc) {
        this.$emit('expired');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.surprise-task-container {
  overflow: hidden;
  position: relative;
  background-color: #fff;
  border-radius: 0.12rem;
  padding-top: 0.14rem;
  background-image: url("https://m.hellobike.com/2d16a8af_surprise-title-bg.png");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 100% auto;

  .img {
    position: absolute;
    right: 0.12rem;
    top: -0.04rem;
    width: 0.54rem;
    height: auto;
    /* stylelint-disable-next-line property-no-unknown */
    aspect-ratio: 54 / 73;
  }

  .header {
    display: flex;
    align-items: center;
    padding: 0 0.12rem;
    margin-bottom: 0.02rem;

    .header-title {
      color: #242729;
      font-size: 0.15rem;
      font-weight: 600;
    }

    .header-icon {
      width: 0.15rem;
      height: 0.15rem;
      margin-left: 0.06rem;
    }

    .header-desc {
      font-size: 0.12rem;
      font-weight: 600;
      color: #fb750f;
      margin-left: 0.02rem;
    }
  }

  .task {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0.12rem;

    .task-left {
      display: flex;

      .task-left-img {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.12rem;
        overflow: hidden;
      }

      .task-info {
        display: flex;
        flex-direction: column;
        margin-left: 0.1rem;
        padding-top: 0.02rem;

        .task-title {
          color: #242729;
          font-size: 0.14rem;
          font-weight: 500;
          max-width: 1.9rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .task-title-row {
          display: flex;
          align-items: baseline;

          .task-title {
            color: #242729;
            font-size: 0.14rem;
            font-weight: 500;
          }

          .tiered-progress-tag {
            font-size: 0.12rem;
            font-weight: 400;
            color: #5a6066;
            white-space: nowrap;
          }
        }

        .task-coin {
          display: flex;
          align-items: center;
          margin-top: 0.02rem;

          .task-icon {
            width: 0.16rem;
            height: 0.16rem;
          }

          .task-amount {
            margin-left: 0.02rem;
            color: #fe852a;
            font-size: 0.12rem;
            font-weight: 600;
          }

          .coupon-badge {
            margin-left: 0.08rem;
            display: flex;
            align-items: center;
            height: 0.18rem;
            border-radius: 0.06rem;
            overflow: hidden;
            border: 0.01rem solid #ffe3e0;
            background-color: #fff;
            width: fit-content;
            flex-shrink: 0;

            .coupon-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 0.19rem;
              height: 0.18rem;
              background-color: #ffe3e0;
              flex-shrink: 0;

              img {
                width: 0.15rem;
                height: 0.15rem;
              }
            }

            .coupon-text {
              padding: 0 0.04rem;
              font-size: 0.11rem;
              font-weight: 500;
              color: #ff5729;
              line-height: 0.16rem;
              white-space: nowrap;
            }
          }

          .task-subtitle {
            margin-left: 0.08rem;
            color: rgba(90, 96, 102, 0.8);
            max-width: 1.6rem;
            font-size: 0.12rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .task-right {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 0.62rem;
      height: 0.28rem;
      font-weight: 500;
      background-color: #ffe888;
      border-radius: 1rem;
      color: #000;
      font-size: 0.12rem;
      z-index: 2;

      &.disabled {
        background: #f0f3f5 !important;
        color: #bcc4cc !important;
      }
    }

    .done {
      background: #fe852a;
      color: #fff;
    }

    .can-do {
      background: #fff;
      color: #fb750f;
      border: 0.01rem solid #ff8000;
    }
  }
}
</style>
